/*
 * File: 考勤规则配置表单
 */
<template>
    <div class="rulesSettingsFormWrap">
        <div class="btnBox">
            <el-button type="primary" @click="submitForm">保存规则</el-button>
        </div>

        <p class="title">基础配置</p>

        <el-form
            class="rulesSettingsForm"
            :model="ruleForm"
            :rules="rules"
            ref="ruleFormRef"
            label-width="135px"
            v-loading="loading"
        >

            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="考勤规则名称" prop="ruleName">
                        <el-input v-model="ruleForm.ruleName" placeholder="请输入考勤规则名称"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="使用部门" prop="depts">
                        <el-select v-model="ruleForm.depts" multiple filterable collapse-tags placeholder="请选择部门" style="width: 100%;">
                            <el-option
                                v-for="item in manageOrgList"
                                :key="item.orgCode"
                                :label="item.fullName"
                                :value="item.orgCode"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="上班时间" prop="workStartTime">
                        <el-time-picker placeholder="请选择上班时间" format="HH:mm" value-format="HH:mm" v-model="ruleForm.workStartTime" style="width: 100%;"></el-time-picker>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="下班时间" prop="workEndTime">
                        <el-time-picker placeholder="请选择下班时间" format="HH:mm" value-format="HH:mm" v-model="ruleForm.workEndTime" style="width: 100%;"></el-time-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="上班打卡时间范围" prop="morningCheckTime">
                        <el-time-picker
                            is-range
                            v-model="ruleForm.morningCheckTime"
                            @change="(v) => timeHandleChange(v, 'morningCheckStart', 'morningCheckEnd')"
                            style="width: 100%;"
                            format="HH:mm"
                            value-format="HH:mm"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                        </el-time-picker>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="下班打卡时间范围" prop="afternoonCheckTime">
                        <el-time-picker
                            is-range
                            v-model="ruleForm.afternoonCheckTime"
                            @change="(v) => timeHandleChange(v, 'afternoonCheckStart', 'afternoonCheckEnd')"
                            style="width: 100%;"
                            format="HH:mm"
                            value-format="HH:mm"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                        </el-time-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="允许迟到时长" prop="allowLateMinutes">
                        <el-input v-model="ruleForm.allowLateMinutes" placeholder="请输入允许迟到时长（分钟）" type="number"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="允许早退时长" prop="allowEarlyMinutes">
                        <el-input v-model="ruleForm.allowEarlyMinutes" placeholder="请输入允许早退时长（分钟）" type="number"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="周末允许打卡" prop="weekendEnabled">
                        <el-radio-group v-model="ruleForm.weekendEnabled">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <!-- 打卡点列表 -->
        <list v-if="isCreateSuccess" />

    </div>
</template>

<script>
import { ref, reactive, onMounted, provide } from '@vue/composition-api';
import { Message } from 'element-ui';
import list from './list.vue';
import { createRule, queryManageOrgList } from '@/api/attendanceRuleSettings.js';
import _ from 'lodash';
import store from '@/store';

export default {
    name: 'revenueFactor',
    components: {
        list
    },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // 编辑状态回填数据
        const initData = (data) => {
            if (!data) return;

            // 解构数据并设置默认值
            const {
                id = null,
                type = 'add',
                ruleName = '',
                workStartTime = '',
                workEndTime = '',
                allowLateMinutes = '',
                allowEarlyMinutes = '',
                weekendEnabled = 0,
                depts = [],
                morningCheckStart = '',
                morningCheckEnd = '',
                afternoonCheckStart = '',
                afternoonCheckEnd = ''
            } = data;

            // 批量赋值
            Object.assign(ruleForm, {
                id,
                type,
                ruleName,
                workStartTime,
                workEndTime,
                allowLateMinutes,
                allowEarlyMinutes,
                weekendEnabled,
                morningCheckStart,
                morningCheckEnd,
                afternoonCheckStart,
                afternoonCheckEnd
            });

            // 处理部门数组
            ruleForm.depts = depts.map(item => item.deptCode);

            // 处理时间范围数组
            ruleForm.morningCheckTime = morningCheckStart && morningCheckEnd
                ? [morningCheckStart, morningCheckEnd]
                : ruleForm.morningCheckTime;

            ruleForm.afternoonCheckTime = afternoonCheckStart && afternoonCheckEnd
                ? [afternoonCheckStart, afternoonCheckEnd]
                : ruleForm.afternoonCheckTime;

            if (type === 'edit') {
                ruleId.value = id;
                isCreateSuccess.value = true;
            }
        };

        // 表单引用
        const ruleFormRef = ref(null);

        // 表单数据
        const ruleForm = reactive({
            ruleName: '',
            workStartTime: '',
            workEndTime: '',
            morningCheckTime: '',
            afternoonCheckTime: '',
            morningCheckStart: '',
            morningCheckEnd: '',
            afternoonCheckStart: '',
            afternoonCheckEnd: '',
            allowLateMinutes: '',
            allowEarlyMinutes: '',
            weekendEnabled: 0,
            depts: []
        });

        // 表单验证规则
        const rules = reactive({
            ruleName: [
                { required: true, message: '请输入考勤规则名称', trigger: 'blur' }
            ],
            workStartTime: [
                { required: true, message: '请选择上班时间', trigger: 'change' }
            ],
            workEndTime: [
                { required: true, message: '请选择下班时间', trigger: 'change' }
            ],
            morningCheckTime: [
                { type: 'array', required: true, message: '请选择上班打卡时间范围', trigger: 'change' }
            ],
            afternoonCheckTime: [
                { type: 'array', required: true, message: '请选择下班打卡时间范围', trigger: 'change' }
            ],
            allowLateMinutes: [
                { required: true, message: '请输入允许迟到时长', trigger: 'blur' }
            ],
            allowEarlyMinutes: [
                { required: true, message: '请输入允许早退时长', trigger: 'blur' }
            ],
            depts: [
                { type: 'array', required: true, message: '请选择部门', trigger: 'change' }
            ]
        });

        // 处理时间范围选择
        const timeHandleChange = (v, start, end) => {
            if (v.length) {
                ruleForm[start] = v[0];
                ruleForm[end] = v[1];
            }
        };

        // 提交表单
        const ruleId = ref(null);
        // 提供响应式数据
        provide('ruleId', ruleId);
        const loading = ref(false);
        const isCreateSuccess = ref(false);
        const submitForm = (formName) => {
            const formRef = ruleFormRef.value;
            if (formRef) {
                formRef.validate((valid) => {
                    if (valid) {
                        const params = _.cloneDeep(ruleForm);
                        Reflect.deleteProperty(params, 'afternoonCheckTime');
                        Reflect.deleteProperty(params, 'morningCheckTime');
                        if (params.type === 'add') {
                            Reflect.deleteProperty(params, 'id');
                        }
                        if (params.type === 'edit') {
                            params.ruleId = ruleId.value;
                        }
                        // console.log(params);
                        let list = [];
                        if (params.depts.length) {
                            list = params.depts.map(item => ({
                                deptCode: item,
                                deptName: manageOrgList.value.find(org => org.orgCode === item)?.fullName || ''
                            }));
                        }
                        params.depts = list;
                        loading.value = true;
                        createRule(params).then(res => {
                            if (+res.code === 0) {
                                loading.value = false;
                                Message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                                ruleId.value = res.data.id;
                                isCreateSuccess.value = true;
                                // 把接口需要的参数带进去
                                setupContext.emit('createFinish', ruleForm);
                            } else {
                                loading.value = false;
                                Message({
                                    message: res.msg || '提交失败',
                                    type: 'error'
                                });
                            }
                        });
                    }
                });
            }
        };

        // 查询用户管理的所有组织
        const manageOrgList = ref([]);
        const getManageOrgList = () => {
            queryManageOrgList({ userCode: store.getters.user.userCode }).then(res => {
                if (+res.code === 0) {
                    manageOrgList.value = res.data;
                }
            });
        };

        onMounted(() => {
            getManageOrgList();
            if (props.data) {
                initData(props.data);
            }
        });

        return {
            rules,
            ruleForm,
            ruleFormRef,
            submitForm,
            timeHandleChange,
            isCreateSuccess,
            ruleId,
            loading,
            manageOrgList
        };
    }
};
</script>

<style lang="less" scoped>
.rulesSettingsFormWrap {
    .btnBox {
        margin-bottom: 20px;
    }

    .title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 20px;
        position: relative;

        .addNewAddr {
            position: absolute;
            right: 0;
            top: 0;
        }
    }

    .rulesSettingsForm {
        overflow: hidden;
    }
}
</style>
